import {
  ChangeDetectorRef,
  Component,
  NgZone,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';
import { isLargeScreen } from '../global.variable';
import { LoadingSpinnerService } from './shared/services/loading-spinner.service';
import { OrientationLockService } from './shared/services/orientationlock.service';
import { ToasterService } from './shared/services/toaster.service';
import { SyncClockService } from './shared/services/sync-clock.service';
import { NativeBgUploadService } from './shared/services/native-bg-upload.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  showSpinner: boolean = false;
  spinnerMessage = 'Loading... ';
  private spinnerServiceSubscription: any;

  successTick?: 'isNativeApp' | boolean = false;
  failureCross?: 'isNativeApp' | boolean = false;

  successMessage: string = '';
  errorMessage: string = '';

  messageStyle: any = {
    'z-index': 1002, // 1000 is inbuilt for cdk-overlay container
    'position': 'fixed',
    'right': 0,
    'padding': '1rem',
  };

  isDotLive: boolean = false;
  isPwa = Boolean(window.matchMedia('(display-mode: standalone)').matches);
  hideSpinnerManualOption: boolean = false;
  hideSpinnerTimeOut: any;
  slowSpinnerTimeOut: any;
  largeView: Boolean = isLargeScreen;

  isNativeApp = Capacitor.isNativePlatform();
  constructor(
    private spinnerService: LoadingSpinnerService,
    private toasterService: ToasterService,
    private cdRef: ChangeDetectorRef,
    private ngZone: NgZone,
    private orientationService: OrientationLockService,
    private clockService: SyncClockService,
    private router: Router,
    private nativeUploadService: NativeBgUploadService,
  ) {}

  clearAlert() {
    this.successMessage = '';
    this.errorMessage = '';
  }

  async ngOnInit() {
    if (Capacitor.isNativePlatform()) {
      this.setupDeepLinks();
      this.nativeUploadService.start();
    }
    this.clockService.init();
    this.clockService.sync();
    this.isDotLive = Boolean(window.location.host === 'app.guardtracker.live');
    screen.orientation.addEventListener('change', (event: any) => {
      this.orientationService.isLargeScreen.next(true);
    });
    this.toasterService.returnMessage().subscribe((msg) => {
      this.ngZone.run(() => {
        if (msg?.errorMessage) {
          this.errorMessage = msg?.errorMessage;
          setTimeout(() => {
            this.clearAlert();
          }, msg?.timeOut ?? 5000);
        }
        if (msg?.successMessage) {
          this.successMessage = msg?.successMessage;
          setTimeout(() => {
            this.clearAlert();
          }, msg?.timeOut ?? 5000);
        }
        if (msg?.successTick) {
          this.successTick = msg?.successTick;

          setTimeout(() => {
            this.successTick = false;
          }, msg?.timeOut ?? 1000);
        }
        if (msg?.failureCross) {
          this.failureCross = msg?.failureCross;
          setTimeout(() => {
            this.failureCross = false;
          }, msg?.timeOut ?? 1000);
        }
      });
    });
    this.spinnerServiceSubscription = this.spinnerService.isLoading$.subscribe(
      (isLoading) => {
        this.hideSpinnerManualOption = false;
        this.showSpinner = Boolean(isLoading);
        this.spinnerMessage = typeof isLoading === 'string' ? isLoading : '';
        if (this.hideSpinnerTimeOut) clearTimeout(this.hideSpinnerTimeOut);
        if (this.slowSpinnerTimeOut) clearTimeout(this.slowSpinnerTimeOut);

        if (this.showSpinner) {
          this.slowSpinnerTimeOut = setTimeout(() => {
            if (this.showSpinner)
              this.spinnerMessage =
                'This is taking longer than expected. We appreciate your patience.';
          }, 10000);

          this.hideSpinnerTimeOut = setTimeout(() => {
            if (this.showSpinner) this.hideSpinnerManualOption = true;
          }, 12500);
        }

        this.cdRef.detectChanges();
      },
    );
  }

  ngOnDestroy(): void {
    this.spinnerServiceSubscription?.unsubscribe();
  }
  pageReload() {
    window.location.reload();
  }
  setupDeepLinks() {
    App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      this.ngZone.run(async () => {
        const fullUrlString = event.url;
        const url = new URL(fullUrlString);

        if (url.pathname.includes('/webapp')) {
          await Browser.open({ url: fullUrlString });
          return;
        }

        const slug = url.pathname.replace(/^\/+|\/+$/g, '');

        if (slug) {
          setTimeout(() => {
            this.router
              .navigateByUrl('/' + slug)

              .catch((error) => {
                console.error('Navigation failed:', error);
              });
          }, 100);
        }
      });
    });
  }
}
